import React, { useEffect } from 'react';
import { useAnalytics } from "../../hooks/useAnalytics";
 
const Download = () => {
  useAnalytics();

  useEffect(() => {
    // List of platform keywords
    const iOSKeywords = ["iPhone", "iPad", "iPod"];
    const androidKeywords = ["Android"];
 
    // Function to get User-Agent from the response headers
    const getUserAgent = async () => {
      const response = await fetch(window.location.href, { method: "HEAD" });
      const userAgent = response.headers.get("User-Agent") || "";
      return userAgent;
    };
 
    // Check device type from User-Agent
    const redirectBasedOnDevice = async () => {
      const userAgent = await getUserAgent();

      console.log({userAgent})
 
      // Check for iOS
      const isIOS = iOSKeywords.some(keyword => userAgent.includes(keyword));
 
      // Check for Android
      const isAndroid = androidKeywords.some(keyword => userAgent.includes(keyword));
 
      // Perform redirection
      if (isIOS) {
        window.location.href = "https://apps.apple.com/ng/app/nimblecasa-apartments/id6740244804"; // Replace with your iOS URL
      } else if (isAndroid) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.google.android.googlequicksearchbox"; // Replace with your Android URL
      } else {
        console.log("Device type not recognized.");
      window.location.href = "https://booking.nimblecasa.com";  

      }
    };
 
    // Trigger redirection
    redirectBasedOnDevice();
  }, []);
 
  return (
<div>
<h1>Redirecting based on device...</h1>
</div>
  );
};
 
export default Download;